module.exports = __webpack_public_path__ + "static/img/db1_pc.61309b27.jpg";